import React from "react"

export const SUBSCRIPTIONS_ITEM_VERSION = (version) => { 
    return <React.Fragment>Версия мода <mark>{version}</mark></React.Fragment>
 }
export const SUBSCRIPTIONS_ITEM_UDATED_DATE = (date) => { 
    return <React.Fragment>Обновлён: <mark>{date}</mark></React.Fragment>
 }
export const SUBSCRIPTIONS_ITEM_DOWNLOAD_LABEL = (size) => { 
    return <React.Fragment>Cкачать мод <mark>({size})</mark></React.Fragment>
 }